/* eslint-disable */
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { checkIdtfFeatureEnabled } from 'configs'
import styles from './Forms.css'
import TextInput from '../../containers/Forms/components/TextInput'
import TextAreaInput from '../../containers/Forms/components/TextAreaInput'
import MaskedInput from '../../containers/Forms/components/MaskedInput'
import ReactSelectDropdownInput from '../../containers/Forms/components/ReactSelectDropdownInput'
import {
  emailMask,
  phoneNumberMask,
  getDateOfBirthMask,
  dateValidation,
} from '../../containers/Forms/components/formValidations'
import { getOrderingProviderName, getNameIdtf } from '../../containers/Utilities'
import { UNASSIGNED_ORDERING_PHYSICIAN_OPTION, FORM_SEX_OPTIONS, getDateOfBirthFormat } from '../../constants'
import { filterIsPhysicianPermission } from '../../store/appReducer'

class PatientDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      disabled: {
        firstName: true,
        lastName: true,
        customParticipantID: true,
        sex: true,
        email: true,
        dob: true,
        orderingPhysician: true,
        phone: true,
        notes: true,
      },
    }
  }

  render() {
    const {
      handleSubmit,
      physicians,
      invalid,
      pristine,
      submitting,
      isSubmitting,
      me,
      initialValues: {
        customParticipantID,
        firstName,
        lastName,
        middleName,
      },
    } = this.props

    const {
      disabled,
    } = this.state

    let physicianOptions = [ UNASSIGNED_ORDERING_PHYSICIAN_OPTION ]

    console.log('firstname', firstName)
    const isIdtfEnabled = checkIdtfFeatureEnabled(me)

    if (physicians && physicians.data) {
      physicianOptions = [
        ...physicianOptions,
        ...filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id])),
      ]
    }

    const getEditClassName = field => (disabled[field] ? 'editIcon' : 'editIconActive')

    return (
      <form>
        <div className={styles.editPatientSection}>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('firstName')]} >
              </div> */}
              {
                isIdtfEnabled ?
                <div style={{ display: 'block' }} className={styles.editLabelGroupForEnroll}>
                  <div className={styles.inputGroup}>
                    <span className={styles.label}>Name</span>
                    <div className={styles.fakeInput}>
                      {`${firstName} ${lastName}`}
                    </div>
                  </div>
                </div> :
                <Field
                  component={TextInput}
                  label="Name"
                  name="firstName"
                  disabled={true}
                />
              }
            </div>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('customParticipantID')]}>
              </div> */}
              <Field
                component={TextInput}
                label="MRN"
                name="customParticipantID"
                disabled={true}
              />
            </div>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('phone')]}>
              </div> */}
              <Field
                component={MaskedInput}
                mask={phoneNumberMask}
                label="Phone Number"
                name="phone"
                disabled={true}
              />
            </div>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('orderingPhysician')]}>
              </div> */}
              <Field
                component={ReactSelectDropdownInput}
                label="Ordering Provider"
                name="orderingPhysician"
                isLoading={physicians && physicians.isFetching}
                isClearable={false}
                backspaceRemovesValue={false}
                placeholder="Unassigned"
                options={physicianOptions}
                noOptionsMessage="No provider found"
                getOptionLabel={p => getOrderingProviderName(p.firstName, p.lastName, p.customParticipantID)}
                getOptionValue={p => p.id}
                disabled={true}
              />
            </div>
          </div>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('dob')]}>
              </div> */}
              <Field
                component={MaskedInput}
                mask={getDateOfBirthMask(me)}
                label="Date of Birth"
                name="dob"
                disabled={true}
              />
            </div>
            <div className={styles.editLabelGroup}>
              <Field
                component={ReactSelectDropdownInput}
                label="Sex"
                name="sex"
                placeholder="Select a sex"
                options={FORM_SEX_OPTIONS}
                noOptionsMessage="No Sex found"
                getOptionLabel={p => p.label}
                getOptionValue={p => p.value}
                disabled={disabled.sex}
              />
            </div>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('email')]}>
              </div> */}
              <Field
                component={MaskedInput}
                mask={emailMask}
                label="Email"
                name="email"
                disabled={true}
              />
            </div>
            <div className={styles.editLabelGroup}>
              {/* <div className={styles[getEditClassName('email')]}>
              </div> */}
              <Field
                component={TextInput}
                label="Implantable Devices"
                name="implantedDevice"
                disabled={true}
              />
            </div>
          </div>
          <div className={styles.formSectionRow}>
            <div className={styles.editLabelGroupFull}>
              <Field
                component={TextInput}
                label="Notes"
                name="notes"
                disabled={true}
              />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'patientDetailForm',
  enableReinitialize: true,
})(PatientDetail)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/PatientDetail.jsx